import { ALL_SUPPLIERS, SEARCH_SUPPLIERS, FILTER_SUPPLIERS, CLEAR_FILTER_SUPPLIERS, ALERT_SESSION } from "../action-types.js";
import axios from "axios"
import {url, urlFront} from "../../App.js";


export const getAllSuppliers = () => {
    return async (dispatch) => {
        try {
            const config = {
                method: 'get',
                url: `${url}/suppliers/`,
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            };
            const response = await axios(config)
            dispatch({
                type: ALL_SUPPLIERS,
                payload: response.data
            })
        } catch (error) {
            const errorResponse = {};
            errorResponse.error = error.message;

            if(error.response.status === 401) {
                dispatch({
                    type: ALERT_SESSION,
                    payload: true
                })

                setTimeout(() => {
                    localStorage.clear('globalState')
                    window.location.replace(urlFront)
                }, [3000])
                
            }  
            return errorResponse;    
        } 
    }
}
export const getFilterSuppliers = (filtros) => {
    return async (dispatch) => {
        try {
            const config = {
                method: 'post',
                url: `${url}/suppliers/filter`,
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
                data: filtros
            };
            const response = await axios(config)
            if (response.status === 200) {
                dispatch({
                    type: FILTER_SUPPLIERS,
                    payload: response.data.elements
                })
            }
            else if (response.status === 204) {
                dispatch({
                    type: FILTER_SUPPLIERS,
                    payload: ["Sin resultados"]
                })
            }
        } catch (error) {
            const errorResponse = {};
            errorResponse.error = error.message;
            if(error.response.status === 401) {
                dispatch({
                    type: ALERT_SESSION,
                    payload: true
                })

                setTimeout(() => {
                    localStorage.clear('globalState')
                    window.location.replace(urlFront)
                }, [3000])
                
            }  
            return errorResponse;    
        } 
    }
}
export const getSearchSuppliers = (partialId) => {
    return async (dispatch) => {
        try {
            const config = {
                method: 'get',
                url: `${url}/supplier/search/${partialId}`,
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            };
            const response = await axios(config)
            if (response.status === 200) {
                dispatch({
                    type: SEARCH_SUPPLIERS,
                    payload: response.data.elements
                })
            }
            else if (response.status === 204) {
                dispatch({
                    type: SEARCH_SUPPLIERS,
                    payload: ["Sin resultados"]
                })
            }
        } catch (error) {
            const errorResponse = {};
            errorResponse.error = error.message;
            if(error.response.status === 401) {
                dispatch({
                    type: ALERT_SESSION,
                    payload: true
                })

                setTimeout(() => {
                    localStorage.clear('globalState')
                    window.location.replace(urlFront)
                }, [3000])
                
            }  
            return errorResponse;    
        } 
    }
}

export const clearFilterSuppliers = () => {
    return {
      type: CLEAR_FILTER_SUPPLIERS,
    };
  };